'use strict';

import {element_exists} from "../functions";
import {addSelectedCompanyHandler, getSelectedCompany, pjaxRedirect} from "../jquery-functions-library";

const queryString = require('query-string');
const setQuery = require('set-query-string');

export var fnViiaAccountsSelect = function () {

    let tableName = '#datatable-viia-transactions';

    if (!element_exists(tableName)) return false;

    let account_ids = $('#account_ids');

    account_ids.select2({width: '100%'});

    account_ids.off('select2:select').on('select2:select', function (e) {
        setQuery({
            transaction_from_amount: $('#transaction_from_amount').val(),
            transaction_to_amount: $('#transaction_to_amount').val(),
            transaction_from_date: $('#transaction_from_date').val(),
            transaction_to_date: $('#transaction_to_date').val(),
            account_id: $('#account_ids').val()
        });

        $(tableName).DataTable().ajax.reload();
    });

    addSelectedCompanyHandler(function () {
        account_ids.empty().attr('disabled', true);
    });
}